import './PortProductCertificates.css'
import 'antd/dist/reset.css'
import React from 'react'
import Certificates1 from '../../../images/certificate/certificates_1.jpeg'

export default class PortProductCertificates extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div className="PortProductCertificates">
        <img className="PortProductCertificatesImage" src={Certificates1} />
        <div className="PortProductCertificatesText">
          <div className="PortProductCertificatesName">
            质量管理体系认证证书
          </div>
          <div className="PortProductCertificatesContent">
            质量管理体系认证证书是第三方机构对企业质量管理体系符合国际或国家标准（如ISO
            9001）的正式认可证明。它表明企业已建立并有效运行规范化的质量管理体系，能够持续提供合格产品或服务。证书通常包含企业名称、认证标准、范围、有效期及发证机构信息，常用于提升客户信任、市场竞争力及合规性。认证需通过审核并定期监督维持。
          </div>
        </div>
      </div>
    )
  }
}
